import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ProviderConnectionState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ProviderConnectionState = {
  providerConnections: [],
  providerConnectionStatus: [1,0],
};

export const providerConnections: Module<ProviderConnectionState,RootState> = {
  state,
  getters,
  actions,
  mutations
};